import { render } from "./card.vue?vue&type=template&id=0b8fdb56"
const script = {}

const cssModules = {}
import style0 from "./card.vue?vue&type=style&index=0&id=0b8fdb56&module=true&lang=css"
cssModules["$style"] = style0
if (module.hot) {
  module.hot.accept("./card.vue?vue&type=style&index=0&id=0b8fdb56&module=true&lang=css", () => {
    cssModules["$style"] = style0
    __VUE_HMR_RUNTIME__.rerender("0b8fdb56")
  })
}

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__file',"resources/js/common/shared/components/card.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b8fdb56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b8fdb56', __exports__)) {
    api.reload('0b8fdb56', __exports__)
  }
  
  module.hot.accept("./card.vue?vue&type=template&id=0b8fdb56", () => {
    api.rerender('0b8fdb56', render)
  })

}


export default __exports__